import {Directive, ElementRef, HostListener, Input, NgModule, OnInit, Renderer2} from '@angular/core';

@Directive({
  selector: '[appShadowBox]'
})
export class ShadowBoxDirective implements OnInit {
  boxShadow = " 0px 20px 30px -10px";
  // rgb(38, 57, 77) 
  @Input()
  appShadowBox: string;
  constructor(private elRef: ElementRef, private renderer: Renderer2) {
  }

  ngOnInit() {

  }
  @HostListener('mouseenter') mouseover(eventData: Event) {
    this.renderer.setStyle(this.elRef.nativeElement, 'box-shadow',this.appShadowBox + this.boxShadow)
  }

  @HostListener('mouseleave') mouseleave(eventData: Event) {
    this.renderer.removeStyle(this.elRef.nativeElement, 'box-shadow')
  }
  
}